import { render } from "./OtherPaymentSection.vue?vue&type=template&id=16ef31ae&scoped=true"
import script from "./OtherPaymentSection.vue?vue&type=script&lang=js"
export * from "./OtherPaymentSection.vue?vue&type=script&lang=js"

import "./OtherPaymentSection.vue?vue&type=style&index=0&id=16ef31ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ef31ae"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
